import { createAction, createReducer } from "redux-act";

import { reducerRegistry } from "../reducerRegistry";
import { featureId } from "./utils";

import { FeatureDcExtended, SelectFeaturesState } from "./types";

const reducerName = "selectFeatures";

const initialState: SelectFeaturesState = {
  initialized: false,
  layerName: undefined,
  currentId: null,
  features: {},
  totalCounts: {},
  statisticsActive: false,
  geometryMasking: false,
};

export const reducer = createReducer({}, initialState);
export const setNextFeature = createAction(`${reducerName}/set-next-feature`);
export const setPrevFeature = createAction(`${reducerName}/set-prev-feature`);
export const setSelectedFeatures = createAction<Record<string, FeatureDcExtended[]>>(
  `${reducerName}/set-selected-features`,
);
export const setSelectedFeaturesTotalCounts = createAction<Record<string, number>>(
  `${reducerName}/set-selected-features-total-counts`,
);
export const resetSelectedFeatures = createAction(`${reducerName}/reset-selected-features`);
export const setSelectFeaturesInitialized = createAction<boolean>(`${reducerName}/set-select-features-initialized`);
export const setSelectFeaturesLayerName = createAction<string>(`${reducerName}/set-select-features-layer-name`);
export const setSelectFeaturesStatisticsActive = createAction<boolean>(`${reducerName}/set-select-features-active`);
export const setSelectFeaturesGeometryMasking = createAction<boolean>(
  `${reducerName}/set-select-features-geometry-masking`,
);

reducer.on(setSelectFeaturesInitialized, (state, initialized) => ({
  ...state,
  initialized,
}));

reducer.on(setSelectedFeatures, (state, features) => {
  const firstNotNullLayerName = Object.keys(features).find(key => features[key].length > 0);
  const featureIdsToSelect = features[firstNotNullLayerName]?.map(featureId);

  return {
    ...state,
    features,
    layerName: firstNotNullLayerName,
    currentId: featureIdsToSelect?.[0],
  };
});

reducer.on(setPrevFeature, state => {
  const { layerName, features, currentId } = state;
  const currentIndex = features?.[layerName]?.findIndex(item => item.id === currentId);

  if (currentIndex === 0) {
    return state;
  }

  const prevId = features?.[layerName]?.[currentIndex - 1]?.id;

  return {
    ...state,
    currentId: prevId,
  };
});

reducer.on(setNextFeature, state => {
  const { layerName, features, currentId } = state;
  const currentIndex = features?.[layerName]?.findIndex(item => item.id === currentId);

  if (currentIndex === features?.[layerName]?.length - 1) {
    return state;
  }

  const nextId = features?.[layerName]?.[currentIndex + 1]?.id;

  return {
    ...state,
    currentId: nextId,
  };
});

reducer.on(resetSelectedFeatures, () => initialState);

reducer.on(setSelectFeaturesLayerName, (state, payload) => ({
  ...state,
  layerName: payload,
  currentId: state.features?.[payload]?.[0]?.id,
}));

reducer.on(setSelectFeaturesStatisticsActive, (state, payload) => ({
  ...state,
  statisticsActive: payload,
}));

reducer.on(setSelectedFeaturesTotalCounts, (state, payload) => ({
  ...state,
  totalCounts: payload,
}));

reducer.on(setSelectFeaturesGeometryMasking, (state, payload) => ({
  ...state,
  geometryMasking: payload,
}));

reducerRegistry.register(reducerName, reducer);
